/** Converts a numeric `0xRRGGBB` color (as used throughout `GameConfig.colors`) to a CSS `#rrggbb` string, for Phaser Text styles. */
export function hexToCss(hex: number): string {
  return `#${hex.toString(16).padStart(6, "0")}`;
}

/**
 * Linearly blends two `0xRRGGBB` colors, per-channel - `ratio` 0 is pure
 * `from`, 1 is pure `to`. Pure and framework-independent (no
 * `Phaser.Display.Color` dependency) so it stays usable from any plain
 * source-level/unit test in this project. `ratio` is clamped to `[0, 1]`
 * so a caller passing a value computed from something like a capped stack
 * count can never accidentally overshoot into (or past) pure `to`.
 */
export function mixColors(from: number, to: number, ratio: number): number {
  const t = Math.max(0, Math.min(1, ratio));
  const mixChannel = (shift: number) => {
    const a = (from >> shift) & 0xff;
    const b = (to >> shift) & 0xff;
    return Math.round(a + (b - a) * t);
  };
  return (mixChannel(16) << 16) | (mixChannel(8) << 8) | mixChannel(0);
}
